<template>
    <button
        v-if="page != 'elipsis'"
        class="pagination-button page-number"
        :class="{ current: iscurrent }"
        @click="changePage"
    >
        {{ page }}
    </button>
    <div v-else class="elipsis">...</div>
</template>

<script>
export default {
    props: ['page', 'iscurrent', 'elipsis'],
    name: 'page-button',
    methods: {
        changePage() {
            this.$store.dispatch('changePage', this.page).then(() => {
                this.$store.dispatch('getList');
            });
        },
    },
};
</script>
